import styled from 'styled-components';

export const ExamListContainer = styled.div`
  &.exam-list {
    height: 100%;
    background-color: #000000;
    overflow-y: auto;
    position: relative;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    width: 300px;
    transition: transform 0.3s ease-in-out;
    padding: 16px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.3);
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 3px;
    }

    @media (max-width: 768px) {
      position: fixed;
      top: 0;
      left: 0;
      height: 100vh;
      z-index: 999;
      transform: translateX(-100%);

      &.open {
        transform: translateX(0);
        margin-top: 50px;
        height: calc(100vh - 50px);
      }
    }
  }
`;

export const SeriesGrid = styled.div`
  &.series-grid {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 32px;

    .selected-series {
      background-color: rgba(52, 152, 219, 0.3) !important;
      border-left: 4px solid #3498db;
      transform: translateX(4px);
    }
  }
`;

export const LoadingMessage = styled.div`
  &.loading {
    padding: 16px;
    text-align: center;
    color: rgba(255, 255, 255, 0.7);
  }
`;

export const ErrorMessage = styled.div`
  &.error {
    padding: 16px;
    text-align: center;
    color: #e74c3c;
    background-color: rgba(231, 76, 60, 0.1);
    margin: 8px;
    border-radius: 4px;
  }
`;
